import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { B2, XStack } from '@zet/design-system'
import { LinearGradient } from 'expo-linear-gradient'

type MagnetBenefitCardProps = {
  item: {
    icon?: string
    title?: string
  }
}

const MagnetBenefitCard = ({ item }: MagnetBenefitCardProps) => {
  return (
    <LinearGradient
      colors={[
        'rgba(202, 195, 245, 0.40)',
        'rgba(139, 187, 243, 0.40) 117.77%)',
      ]}
      start={[0, 0]}
      end={[1, 0.0]}
      className="ml-3 w-[200] rounded-xl p-3"
    >
      <XStack className="justify-between">
        <Image
          source={{
            uri: item?.icon,
          }}
          style={styles.iconStyle}
          className="mt-1"
        />
      </XStack>
      <B2 className="pt-3 text-white">{item?.title}</B2>
    </LinearGradient>
  )
}

const styles = StyleSheet.create({
  iconStyle: { width: 40, height: 40 },
})

export { MagnetBenefitCard }
